
import {
  defineComponent, onMounted, onUnmounted, ref,
} from 'vue';

// import flvjs from 'flv-h265';
import flvjs from 'mpegts.js';

export default defineComponent({
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  setup (props, { emit, }) {
    const isLoading = ref<boolean>(true);
    const player = ref<any>(null);
    // 生成唯一的五位id，用于区别不同页面的调用
    const id = ref<string>((Math.random() * 1e6).toString().substr(0, 5));

    const createPlayer = (url:string) => {
      if (url === '') {
        return;
      }

      if (flvjs.isSupported()) {
        const videoElement = document.getElementById(`videoElement${id.value}`);

        player.value = flvjs.createPlayer({
          type: 'flv',
          url: props.url,
        });

        player.value.attachMediaElement(videoElement);
        player.value.load();
        player.value.play();
      }
    };

    const destroyPlayer = () => {
      if (player.value) {
        player.value.pause();
        player.value.unload();
        player.value.detachMediaElement();
        player.value.destroy();
        player.value = null;
      }
    };

    onMounted(() => {
      createPlayer(props.url);
    });

    onUnmounted(() => {
      destroyPlayer();
    });

    return {
      isLoading,
      id,
    };
  },
});
